import _ from 'lodash';
import { selectUserContextForSegmentTracking } from 'core/userContext/selectors';
import segmentEvents from './segmentEvents';
import segmentHandler from './segmentEmitter';
import { FIRE_SEGMENT_TRACK_CALL } from './actionTypes';

/**
 * Midleware for firing segment events
 *
 * This middleware uses a mapping of action type names to fire segment events when those actions are fired.
 * If an error occurs while trying to format or fire the segment event, the process of firing that event is
 * quietly aborted.
 *
 */

const trackingMiddleware =
  (state /*: Object */) => (next /*: Dispatch<any> */) => (action /*: Action */) => {
    if (segmentEvents[action.type]) {
      try {
        const {
          event,
          eventName,
          eventKeys,
          eventDetailsFormatter,
          eventNameFormatter,
          shouldTrackEvent,
        } = segmentEvents[action.type];

        const eventValues =
          action.type === FIRE_SEGMENT_TRACK_CALL
            ? _.omit(action, 'type')
            : _.pick(action, eventKeys);

        const stateValue = state.getState();

        const isEventTracked = _.isFunction(shouldTrackEvent)
          ? shouldTrackEvent(eventValues, stateValue)
          : true;

        if (isEventTracked) {
          const userState = selectUserContextForSegmentTracking(stateValue);

          const eventProperties = _.isFunction(eventDetailsFormatter)
            ? eventDetailsFormatter(eventValues, stateValue, action)
            : eventValues;

          const formattedEventName = _.isFunction(eventNameFormatter)
            ? eventNameFormatter(action)
            : eventName;

          segmentHandler[event](formattedEventName, { ...eventProperties, ...userState });
        }
      } catch (error) {} // eslint-disable-line
    }
    return next(action);
  };

export default trackingMiddleware;
